export const countriesRoutes = {
    api: {
        base: (): string => '/countries',
    },
};

